var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("section", { staticClass: "section-thai-massage" }, [
      _c("div", { staticClass: "mt-5" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 text-center" }, [
            _c("div", { staticClass: "hero-title" }, [
              _vm._v("บริการนวดแผนไทย")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "hero-title" }, [
              _vm._v("BeNeat Relax - Delivery Thai Massage")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-5" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "button button-large -raised -yellow",
                    attrs: { to: "/relax/professional" }
                  },
                  [_vm._v("จองบริการ")]
                )
              ],
              1
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("section", { staticClass: "section-padding-gray section-solution" }, [
      _c("h2", { staticClass: "text-center" }, [
        _vm._v("ทำไมต้อง BeNeat Relax")
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row space-top-16",
          class: { "vertical-align": _vm.$mq.desktop }
        },
        [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]
      )
    ]),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _c("section", { staticClass: "section-padding" }, [
      _c("div", { staticClass: "row section-therapist" }, [
        _vm._m(6),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-md-7 content-padding mt-4",
            class: { "text-center": _vm.$mq.phone }
          },
          [
            _c("h2", [_vm._v("ใครคือ Therapist ที่มาให้บริการคุณ")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          Therapist ที่ให้บริการในแพลตฟอร์ม คือผู้เชียวชาญที่พักอาศัยในละแวกที่คุณอยู่\u0003เขาเหล่านี้มีความเป็นมิตรและ มีความเชียวชาญในวิชาชีพ\u0003ซึ่งได้รับการคัดเลือกจาก BeNeat เพื่อให้เข้ามาบริการในระบบ\u0003พวกเขามีประสบการณ์สูงและได้รับการฝึกฝนอย่างดี\u0003และพร้อมจะช่วยให้คุณได้รับความผ่อนคลาย จากความเหน็ดเหนื่อย เมื่อยล้า\n        "
              )
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(7),
    _vm._v(" "),
    _c("section", { staticClass: "section-padding-gray section-solution" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-md-4",
            class: _vm.$mq.phone ? "text-center" : "text-right"
          },
          [
            _c("img", {
              attrs: {
                src: "/static/img/beneat-app-thai-massage.png",
                alt: "",
                height: "420"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8 content-padding text-center" }, [
          _c("h2", { staticClass: "text-center" }, [
            _vm._v("ขั้นตอนการจองบริการ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "thai-massage-description" }, [
            _vm._v(
              "\n          สำหรับการจองใช้บริการ หรือสอบถามข้อมูลเพิ่มเติม\u0003คุณลูกค้าสามารถ ทำการคลิกที่ปุ่มด้านล่าง\u0003เพื่อนัดหมายการใช้บริการ\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "thai-massage-description" }, [
            _vm._v(
              "\n          หรือ โทร 02-113-1138 เพื่อติดต่อฝ่ายบริการของเรา\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-5" },
            [
              _c(
                "router-link",
                {
                  staticClass: "button button-large -yellow",
                  attrs: { to: "/relax/professional" }
                },
                [_vm._v("จองเลย")]
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "section-padding section-solution" }, [
      _c("h2", { staticClass: "text-center" }, [
        _vm._v("บริการนวดไทยจาก BeNeat Relax")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-12 col-md-8 offset-md-2 thai-massage-description"
          },
          [
            _vm._v(
              "\n        Thai Massage เป็นศาสตร์การนวดที่มีชื่อเสียงระดับโลก เนื่องจากเป็นศาสตร์ที่ผสมผสานเทคนิคการนวดหลากหลายรูปแบบ\u0003เช่น การกด, คลึง, บีบ, ดัด และ ดึง ซึ่งในแต่ละรูปแบบมีประสิทธิภาพ และจุดประสงค์ในการคลายกล้ามเนื้อและเส้นเอ็นที่ยึดแน่น\u0003จากความตึงเครียด หรือนั่งทำงานเป็นระยะเวลานาน โดยการนวดลักษณะนี้เป็นที่ยอมรับของนานาชาติถึงประสิทธิภาพ\u0003ในการสร้างความรู้สึกผ่อนคลายอย่างสูงสุด โดยเฉพาะเมื่อได้รับการบริการจาก เทอราปีส (Therapist) ที่มีประสบการณ์และความเชี่ยวชาญสูงคุณจะรู้สึกสบาย หายจากความเมื่อยล้าได้อย่างน่าประหลาดใจ\n      "
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 col-md-8 offset-md-2 thai-massage-description" },
        [
          _vm._v(
            "\n        BeNeat Relax คือบริการนวดแบบ Delivery ที่เราคัดเลือก Therapist ที่มีคุณภาพ\u0003และประสบการณ์สูงมาให้บริการถึงที่พัก หรือสำนักงานของคุณ\n      "
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 mb-4" }, [
      _c("img", {
        staticClass: "img-fluid rounded",
        attrs: { src: "/static/img/thai-massage01.jpg", alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 mb-4" }, [
      _c("img", {
        staticClass: "img-fluid rounded",
        attrs: { src: "/static/img/thai-massage02.jpg", alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 mb-4" }, [
      _c("img", {
        staticClass: "img-fluid rounded",
        attrs: { src: "/static/img/thai-massage03.jpg", alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "section-padding section-solution" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6 text-center" }, [
          _c("img", {
            attrs: { src: "/static/img/ic-like-brown.svg", width: "60" }
          }),
          _vm._v(" "),
          _c("h3", [_vm._v("จุดเด่นของบริการ BeNeat Relax")]),
          _vm._v(" "),
          _c("p", { staticClass: "thai-massage-description" }, [
            _vm._v(
              "\n          ผู้ให้บริการผ่านการคัดเลือก • ตรวจสอบประวัติอาชญากรรม\u0003และ ฝึกอบรมหลักสูตรการให้บริการ ผู้ให้บริการมีความเป็นมืออาชีพสูง\u0003และ ได้รับการรับรองจากกระทรวงสาธารณะสุข\n          การให้บริการมีมาตรฐาน ซึ่งคุณลูกค้าจะมั่นใจ\u0003ถึงความคุ้มค่าจากนโยบายการประกันความพอใจ 100%\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 text-center" }, [
          _c("img", {
            attrs: { src: "/static/img/ic-pay-brown.svg", width: "60" }
          }),
          _vm._v(" "),
          _c("h3", [_vm._v("อัตราค่าบริการ")]),
          _vm._v(" "),
          _c("p", { staticClass: "thai-massage-description" }, [
            _vm._v(
              "\n          อัตราค่าบริการเพียง 499 บาท/ชั่วโมง*\u0003โดย Therapist ของเรา พร้อมจะเข้าไปให้บริการคุณ ถึง ที่พัก\u0003หรือ สำนักงาน โดยจัดเตรียมอุปกรณ์การให้บริการที่สะอาด\u0003และมีมาตรฐานอย่างครบครัน\n          *อัตราค่าบริการยังไม่รวมภาษีมูลค่าเพิ่ม\n        "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-5 no-padding" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/static/img/thai-massage04.jpg", alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "section-padding section-solution" }, [
      _c("h2", { staticClass: "text-center" }, [
        _vm._v("กระบวนการคัดเลือกผู้ให้บริการ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-12 col-md-8 offset-md-2 thai-massage-description"
          },
          [
            _vm._v(
              "\n        เนื่องจาก BeNeat ให้ความสำคัญกับความปลอดภัย และ คุณภาพของผู้ให้บริการ ดังน้ั้น Therapist ทุกท่านที่ลงทะเบียนเพื่อเข้ามาให้บริการ\u0003จะต้องผ่านกระบวนการสัมภาษณ์ ตรวจสอบประวัติ และ คัดเลือกอย่างเข้มงวด เพื่อให้แน่ใจว่า คุณจะได้รับการบริการที่ดีที่สุดจากพวกเขา\u0003ซึ่งกระบวนการคัดกรองคือ Therapist ทุกท่าน จะต้องผ่านมาตรฐานการฝึกอบรมจากสถาบันที่มีการรับรองโดยกระทรวงสาธารณะสุข\u0003และ มีจำนวนชั่วโมงการเรียนและให้บริการเพียงพอตามมาตรฐาน จะต้องลงทะเบียนและตรวจสอบประวัติอาชญากรรม ด้วยการพิมพ์ลายนิ้วมือ\u0003ต่อหน้าเจ้าหน้าที่ตำรวจ และ ยื่นเอกสารประจำตัวเพื่อทำทะเบียนประวัติกับ BeNeat ผ่านการสัมภาษณ์ และ ฝึกอบรมมาตรฐานการให้บริการ\u0003อย่างเข้มงวดจากผู้เชี่ยวชาญของ BeNeat Therapist ที่ผ่านเกณฑ์การคัดกรองทั้งหมดนี้เท่านั้น จึงจะสามารถเข้ามาให้บริการ\u0003และเป็นส่วนหนึ่งของชุมชมผู้ให้บริการคุณภาพของ BeNeat\n      "
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a5f3fa4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a5f3fa4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/relax/Home.vue
// module id = 1660
// module chunks = 0